import { DateOptions } from 'coreOld/enums';
import { IDateOption } from 'coreOld/types';
import { getPastDate } from 'coreOld/utils';

const today = new Date();

export const dateOptions: IDateOption[] = [
  {
    id: 0,
    value: null,
    label: DateOptions.ALL,
  },
  {
    id: 1,
    value: { startDate: getPastDate(30), endDate: today },
    label: 'Last 30 Days',
  },
  {
    id: 2,
    value: {
      startDate: getPastDate(90),
      endDate: today,
    },
    label: 'Last 90',
  },
  {
    id: 3,
    value: {
      startDate: getPastDate(0, 0, 1),
      endDate: today,
    },
    label: 'Updated in past year',
  },
  {
    id: 4,
    value: null,
    label: DateOptions.CUSTOM_RANGE,
  },
];
